import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

type Type =
    | 'AUDIENCE'
    | 'DRIP_SEQUENCES'
    | 'FORMS'
    | 'CONNECTED_FORMS'
    | 'LANDING_PAGES'
    | 'VISITOR_IQ';

type Props = {
    totalCount: number | null | undefined;
    type: Type;
};

export function ViewAllLink({totalCount, type}: Props) {
    if (!totalCount) {
        return null;
    }

    let singularNoun = '';
    let pluralNoun = '';
    let url = '';

    switch (type) {
        case 'AUDIENCE':
            singularNoun = 'audience';
            pluralNoun = 'audiences';
            url = '/email-marketing/audiences';
            break;
        case 'DRIP_SEQUENCES':
            singularNoun = 'drip sequence';
            pluralNoun = 'drip sequences';
            url = '/email-marketing/drip-sequences';
            break;
        case 'FORMS':
            singularNoun = 'form';
            pluralNoun = 'forms';
            url = '/email-marketing/forms';
            break;
        case 'CONNECTED_FORMS':
            singularNoun = 'connected form';
            pluralNoun = 'connected forms';
            url = '/email-marketing/connected-forms';
            break;
        case 'LANDING_PAGES':
            singularNoun = 'landing page';
            pluralNoun = 'landing pages';
            url = '/email-marketing/landing-pages';
            break;
        case 'VISITOR_IQ':
            singularNoun = 'visitor';
            pluralNoun = 'visitors';
            url = '/email-marketing/visitors';
            break;
    }

    const linkText =
        totalCount === 1
            ? `View 1 ${singularNoun}`
            : `View all ${totalCount.toLocaleString()} ${pluralNoun}`;

    return (
        // @ts-expect-error
        <Link as={RoutedLink} to={url} variant='primary' size='small'>
            {linkText}
        </Link>
    );
}
